import Modal from '@mui/material/Modal';
import * as React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
// import Modal from '@mui/material/Modal';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  p: 4,
};
export default function OperatorMod() {
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  return (
    <div>
      <Button onClick={handleOpen} style={{color:'teal'}}>Operator Expression</Button>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        
      >
        <Box sx={style} height={300} width={300} style={{'background':'aquamarine'}}>
          <Typography id="modal-modal-title" variant="h6" component="h2">
            Operating Systems
          </Typography>
          <Typography id="modal-modal-description" sx={{ mt: 2 }}>
           Software:-Operator is Generally a symbol or set of symbols that works.<br/>
                     between operands and produces results<br/>

                      There are following types of operators<br/>
                      1. Unary and binary Operators <br/>
                      2. Arithmetic Operators<br/>
                      3. Relational Operators<br/>
                      4. Logical Operators<br/>
                      5. Bitwise Operators<br/>
                      
                        

          </Typography>
        </Box>
      </Modal>
    </div>
  );
}